import React from 'react';

export const GlassSectionHeader = ({
  title,
  trailing,
  className = '',
}) => {
  return (
    <div className={`glass-section-header ${className}`}>
      <span className="title">{title}</span>
      {trailing && <div className="trailing">{trailing}</div>}
    </div>
  );
};